import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { LoadingLine } from '@/components/ui/States';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCan, useCurrentUser } from '@/features/admin-content/use-current-user';
import { AnalyticsDashboard } from '@/features/staff-workspace/AnalyticsDashboard';
import { authClient } from '@/lib/auth-client';

export const Route = createFileRoute('/admin/analytics')({
  component: AdminAnalyticsPage,
});

function AdminAnalyticsPage() {
  const navigate = useNavigate();
  const { data: session, isPending: sessionPending } = authClient.useSession();
  const meQuery = useCurrentUser();
  const allowed = useCan('analytics.read');

  if (sessionPending || meQuery.isPending) {
    return <LoadingLine>Loading</LoadingLine>;
  }

  if (!session) {
    void navigate({ to: '/sign-in' });
    return null;
  }

  if (!allowed) {
    return <StaffOnly />;
  }

  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Workspace"
        title="Analytics"
        description="How the item bank, marking and spend look."
      />
      <AnalyticsDashboard />
    </div>
  );
}
